// extracted by extract-css-chunks-webpack-plugin
module.exports = {"PdfLink":"styles__PdfLink__3tiGX","Link":"styles__Link__ZNrq-","Text":"styles__Text__4cBbW"};